import React, {useState} from 'react';
import {
    Box,
    Button,
    Spinner,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Tfoot,
    Th,
    Thead,
    Tr,
    useColorModeValue,
} from '@chakra-ui/react';
import type {patientDetailsType} from '../../utils/typesConstant/types.tsx';
import {useGetPatientQuery} from "../../store/patientApi/patientApiSlice.ts";
import {useNavigate} from "react-router-dom";
import {RootState} from "../../store/store.ts";
import {useSelector} from "react-redux";


export default function PatientTable() {
    const navigate = useNavigate();
    const textColor = useColorModeValue('white', '#111c44');
    const subTextColor = useColorModeValue('gray.400', 'white');

    const [page, setPage] = useState(1);
    const rowsPerPage = 15;

    const searchValue = useSelector((state: RootState) => state?.search?.value)

    let {data: tempData} = useGetPatientQuery({page: 1, page_size: 500});
    let {data: apiData, isLoading, isError} = useGetPatientQuery({page, page_size: rowsPerPage});

    let filteredData = searchValue.trim()
        ? tempData?.filter(item =>
            item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.doctorName.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.age.toString().includes(searchValue) ||
            item.phone_number.includes(searchValue)
        )
        : apiData;

    const displayData = searchValue.trim() ? filteredData : apiData;

// reset page when searchValue changes
    React.useEffect(() => {
        if (searchValue.trim()) {
            setPage(1);
        }
    }, [searchValue]);

// If search has fewer items than rowsPerPage, no slicing needed.
// If more, slice accordingly:
    apiData = searchValue.trim()
        ? displayData?.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        : displayData;


    const handleNext = () => setPage((prev) => prev + 1);
    const handlePrevious = () => setPage((prev) => Math.max(prev - 1, 1));

    const handleViewClick = (patient: patientDetailsType) => {
        navigate(`/patients/${patient.uid}`);
    };

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                <Spinner size="xl" color="blue"/>
            </Box>
        );
    }

    if (apiData?.length === 0)
        return 'Sorry we could not find any results'

    if (isError || !apiData) {
        return <Text>Error loading patients.</Text>;
    }

    return (
        <Box p={4}>
            <TableContainer borderRadius="lg" boxShadow="sm" bg={textColor}>
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th fontWeight="bold" color={subTextColor}>NAME</Th>
                            <Th fontWeight="bold" color={subTextColor}>AGE</Th>
                            {/*<Th fontWeight="bold" color={subTextColor}>GENDER</Th>*/}
                            <Th fontWeight="bold" color={subTextColor}>PHONE</Th>
                            <Th fontWeight="bold" color={subTextColor}>DOCTOR</Th>
                            <Th fontWeight="bold" color={subTextColor}>PATIENT ID</Th>
                            <Th fontWeight="bold" color={subTextColor}>CREATED AT</Th>
                            <Th fontWeight="bold" color={subTextColor}>ACTIONS</Th>
                        </Tr>
                    </Thead>

                    <Tbody>
                        {apiData.map((row) => (
                            <Tr key={row.uid}>
                                <Td><Text fontWeight="semibold" fontSize="14px">{row.name}</Text></Td>
                                <Td fontWeight="semibold" fontSize="14px">{row.age}</Td>
                                {/*<Td fontWeight="semibold" fontSize="14px">{row.gender}</Td>*/}
                                <Td fontWeight="semibold" fontSize="14px">{row.phone_number}</Td>
                                <Td fontWeight="semibold" fontSize="14px">{row.doctorName}</Td>
                                <Td fontWeight="semibold" fontSize="14px">{row.patient_id}</Td>
                                <Td fontWeight="semibold" fontSize="14px">
                                    {new Date(row.created_at).toLocaleDateString()}
                                </Td>
                                <Td>
                                    <Text
                                        color="#422AFB"
                                        fontWeight="semibold"
                                        cursor="pointer"
                                        onClick={() => handleViewClick(row)}
                                    >
                                        View
                                    </Text>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>

                    <Tfoot>
                        <Tr>
                            <Td colSpan={8}>
                                <Box display="flex" justifyContent="flex-end" alignItems="center" gap={4} pt={4}>
                                    <Button variant="outline" size="sm" onClick={handlePrevious}
                                            isDisabled={page === 1}>
                                        Previous
                                    </Button>
                                    <Text>Page {page}</Text>
                                    <Button
                                        variant="outline"
                                        size="sm"
                                        onClick={handleNext}
                                        isDisabled={apiData.length < rowsPerPage}
                                    >
                                        Next
                                    </Button>
                                </Box>
                            </Td>
                        </Tr>
                    </Tfoot>
                </Table>
            </TableContainer>

            {/*<AddPatientModal*/}
            {/*    open={isModalOpen}*/}
            {/*    setOpen={setIsModalOpen}*/}
            {/*    patientDetails={selectedPatient}*/}
            {/*    setPatientDetails={setSelectedPatient}*/}
            {/*/>*/}
        </Box>
    );
}
